<template>
  <div>
    <div class="item-info">
      <ul class="item-ul" v-for="(item, index) in list.taskDetail" :key="index">
        <li class="item-li">
          <div class="item-left">
            <span>发货编码</span><span>{{ item.sourceNo }}</span>
          </div>
          <div class="item-right">
            <span>货柜</span><span>{{ item.containerNo }}</span>
          </div>
        </li>
        <li class="item-li">
          <div class="item-left">
            <span>调入仓</span><span>{{ item.warehouseName }}</span>
          </div>
          <div class="item-right">
            <span>SKU</span><span>{{ item.skuCode }}</span>
          </div>
        </li>
        <li class="item-li">
          <div class="item-left">
            <span>SKU名称</span
            ><span style="word-break: break-all">{{ item.productNameCN }}</span>
          </div>
          <div class="item-right">
            <span>品牌</span><span>{{ item.brand }}</span>
          </div>
        </li>
        <li class="item-li">
          <div class="item-left">
            <span>是否带电</span><span>{{ item.isElectricityText }}</span>
          </div>
          <div class="item-right">
            <span>是否退税</span><span>{{ item.isReturnTaxText }}</span>
          </div>
        </li>
        <li class="item-li">
          <div class="item-left">
            <span>型号</span><span>{{ item.model }}</span>
          </div>
          <div class="item-right">
            <span>FNSKU</span><span>{{ item.fnsku }}</span>
          </div>
        </li>
        <li class="item-li">
          <div class="item-left">
            <span style="white-space: nowrap; padding-right: 15px"
              >shipmentid</span
            ><span>{{ item.shipmentID }}</span>
          </div>
          <div class="item-right">
            <span>供应商</span><span>{{ item.supplierCode }}</span>
          </div>
        </li>
        <li class="item-li">
          <div class="item-left"></div>
          <div class="item-right" style="white-space: nowrap">
            <span style="flex: 0.3; color: #3d5064"
              >{{ item.actualQty }}/{{ item.quantity }}</span
            ><span style="flex: 0.7">(打包数/调拨数)</span>
          </div>
        </li>
      </ul>
    </div>

    <div class="conventionalBox-info">
      <p class="p-title"><span style="color: red">*</span>常规箱信息</p>

      <div
        class="signInDetail-btnBox"
        v-for="(item, index) in info1"
        :key="index"
      >
        <ul>
          <li>
            <span>单箱数量</span>
            <input
              type="number"
              class="volume fl"
              style="max-width: 23%"
              v-model="item.singleBoxQty"
              @input="inputStockSKUCodeChange(index)"
              @change="inputParseIntNumChange('info1', index, 'singleBoxQty')"
            />
            <span>X <span style="color: #a5081a">箱数</span></span>
            <input
              type="number"
              class="volume fl"
              style="max-width: 23%"
              v-model="item.boxCount"
              @change="inputBoxCodeChange(index)"
              @input="inputParseIntNumChange('info1', index, 'boxCount')"
            />
            <div style="position: relative">
              <span style="margin-left: 5%">总数：</span>
              <span>{{
                Number(item.singleBoxQty) * Number(item.boxCount) || 0
              }}</span>
              <span class="red tips" style="left: -22px" v-if="item.quantityOut"
                >装箱数已超拣货数</span
              >
              <span
                class="red tips"
                style="left: -120px"
                v-if="item.BoxNoOrBoxCount"
                >箱号与箱数不符</span
              >
            </div>
          </li>
          <li>
            <span>长</span>
            <input
              type="number"
              class="volume fl"
              v-model="item.boxLength"
              @input="inputLenChange('info1', index, 'boxLength', 2)"
              @change="inputNumChange('info1', index, 'boxLength', 2)"
              placeholder="输入长(cm)"
            />
            <span>宽</span>
            <input
              type="number"
              class="volume fl"
              v-model="item.boxWidth"
              @input="inputLenChange('info1', index, 'boxWidth', 2)"
              @change="inputNumChange('info1', index, 'boxWidth', 2)"
              placeholder="输入宽(cm)"
            />
            <span>高</span>
            <input
              type="number"
              class="volume fl"
              v-model="item.boxHeight"
              @input="inputLenChange('info1', index, 'boxHeight', 2)"
              @change="inputNumChange('info1', index, 'boxHeight', 2)"
              placeholder="输入高(cm)"
            />
          </li>
          <li>
            <span>毛重</span>
            <input
              type="number"
              class="volume fl"
              style="max-width: 40%"
              v-model="item.boxWeight"
              @input="inputLenChange('info1', index, 'boxWeight', 2)"
              @change="inputNumChange('info1', index, 'boxWeight', 2)"
              placeholder="请输入毛重(kg)"
            />
            <div>
              <van-field
                size="mini"
                v-model="item.inStockSKUCode"
                placeholder="填写调入仓SKU"
                :center="true"
                :border="false"
                clear-trigger="always"
                maxlength="50"
                clearable
              />
            </div>
          </li>
          <li style="position: relative">
            <span class="vm">箱号</span>
            <input
              type="number"
              class="volume fl vm"
              v-model="item.startBoxNo"
              @change="inputParseIntNumChange('info1', index, 'startBoxNo')"
            />
            ~
            <input
              type="number"
              class="volume fl vm"
              v-model="item.endBoxNo"
              @change="inputParseIntNumChange('info1', index, 'endBoxNo')"
            />
            <span class="red tips" style="left: 90px" v-if="item.boxNoRepet"
              >{{ item.startBoxNo }}~{{ item.endBoxNo }}箱号重复</span
            >
            <span class="delInfo" @click="del(1, index)">{{
              info1.length === 1 ? "清空" : "删除"
            }}</span>
            <span class="addInfo" @click="add(1)">添加</span>
          </li>
        </ul>
      </div>
    </div>

    <div class="conventionalBox-info">
      <p class="p-title">尾箱信息</p>

      <div
        class="signInDetail-btnBox"
        v-for="(item, index) in info2"
        :key="index"
      >
        <ul>
          <li style="position: relative">
            <span>单箱数量</span>
            <input
              type="number"
              class="volume fl"
              style="max-width: 32%"
              v-model="item.singleBoxQty"
              @blur="inputStockSKUCodeChange2(index)"
              @change="inputParseIntNumChange('info2', index, 'singleBoxQty')"
            />
            <span class="red tips" style="left: 22px" v-if="item.quantityOut"
              >装箱数已超拣货数</span
            >
            <div>
              <van-field
                size="mini"
                v-model="item.inStockSKUCode"
                placeholder="填写调入仓SKU"
                :center="true"
                :border="false"
                clear-trigger="always"
                maxlength="50"
                clearable
              />
            </div>
          </li>
          <li>
            <span>长</span>
            <input
              type="number"
              class="volume fl"
              v-model="item.boxLength"
              @input="inputLenChange('info2', index, 'boxLength', 2)"
              @change="inputNumChange('info2', index, 'boxLength', 2)"
              placeholder="输入长(cm)"
            />
            <span>宽</span>
            <input
              type="number"
              class="volume fl"
              v-model="item.boxWidth"
              @input="inputLenChange('info2', index, 'boxWidth', 2)"
              @change="inputNumChange('info2', index, 'boxWidth', 2)"
              placeholder="输入宽(cm)"
            />
            <span>高</span>
            <input
              type="number"
              class="volume fl"
              v-model="item.boxHeight"
              @input="inputLenChange('info2', index, 'boxHeight', 2)"
              @change="inputNumChange('info2', index, 'boxHeight', 2)"
              placeholder="输入高(cm)"
            />
          </li>
          <li>
            <span>毛重</span>
            <input
              type="number"
              class="volume fl"
              style="max-width: 40%"
              v-model="item.boxWeight"
              @input="inputLenChange('info2', index, 'boxWeight', 2)"
              @change="inputNumChange('info2', index, 'boxWeight', 2)"
              placeholder="请输入毛重(kg)"
            />
          </li>
          <li style="position: relative">
            <span>箱号</span>
            <input
              type="number"
              class="volume fl"
              v-model="item.startBoxNo"
              @change="inputParseIntNumChange('info2', index, 'startBoxNo')"
            />
            <span class="red tips" style="left: 90px" v-if="item.boxNoRepet"
              >{{ item.startBoxNo }}箱号重复</span
            >
            <span class="delInfo" @click="del(2, index)">{{
              info2.length === 1 ? "清空" : "删除"
            }}</span>
            <span class="addInfo" @click="add(2)">添加</span>
          </li>
        </ul>
      </div>
    </div>

    <div class="photo">
      <p class="p-title">
        <span style="color: red">*</span>打包照片<span style="font-weight: 400"
          >（最少两张）</span
        >
      </p>

      <div class="sign-photo-cpntent">
        <div class="sign-photo-box">
          <ul>
            <li
              class="sign-photo-item"
              v-for="(item, index) in skuImg"
              :key="index"
            >
              <span class="delete-icon" @click="deleteImg(index)">x</span>
              <!-- <van-icon name="photo" size="6em" color="#169bd5"/> -->
              <img
                :src="item"
                class="sign-photo-item-img"
                alt=""
                @click="previewImage(item)"
              />
            </li>

            <li class="sign-photo-btn">
              <div class="photo">
                <input
                  class="img hidden"
                  @change="changeImg()"
                  type="file"
                  name="cover"
                  ref="inputer"
                  accept="image/*"
                  multiple
                />
                <p @click="chooseImage">
                  <i class="el-icon-camera"></i>
                </p>
              </div>
            </li>
          </ul>
        </div>

        <div class="sign-photo-save">
          <button class="submit-btn" @click="submit">保存</button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import {
  Icon,
  Badge,
  Picker,
  Popup,
  Field,
  Toast,
  Empty,
  List,
  Loading,
  Checkbox,
  Tab,
  Tabs,
  SwipeCell,
  Col,
  Row,
  Button,
  Cell,
  Dialog,
  ImagePreview,
} from "vant";
import { mixins } from "../../mobileMixins";
import {
  getBaleSkuDetail,
  getBaleHasBoxNum,
  AddReadyTaskPackaging,
} from "@/api/mobile/bale_api.js";
import { mapMutations } from "vuex";
import { BaseApiUrl } from "@/api/axios_config";
import axios from "axios";
export default {
  data() {
    return {
      list: {},
      info1: [
        // 常规
        {
          singleBoxQty: "",
          boxCount: "",
          boxLength: "",
          boxWidth: "",
          boxHeight: "",
          boxWeight: "",
          inStockSKUCode: "",
          startBoxNo: "",
          endBoxNo: "",
        },
      ],
      info2: [
        // 尾箱
        {
          singleBoxQty: "",
          boxLength: "",
          boxWidth: "",
          boxHeight: "",
          boxWeight: "",
          inStockSKUCode: "",
          startBoxNo: "",
        },
      ],
      skuImg: [],
      imgFiles: [],
      skuCode: "",
      itemName: {
        singleBoxQty: "单箱数量",
        boxCount: "箱数",
        boxLength: "长",
        boxWidth: "宽",
        boxHeight: "高",
        boxWeight: "毛重",
        inStockSKUCode: "调入仓SKU",
        startBoxNo: "开始箱号",
        endBoxNo: "结束箱号",
      },
      isEdit: false, // 是否编辑
      saveImgUrlArr: [],
      saveMaxNoArr: [], // 存储修改后的最大值，编辑状态使用
      shippingPlanDetailIDs: [],
    };
  },
  components: {
    [Icon.name]: Icon,
    [Badge.name]: Badge,
    [Picker.name]: Picker,
    [Popup.name]: Popup,
    [Toast.name]: Toast,
    [List.name]: List,
    [Empty.name]: Empty,
    [Loading.name]: Loading,
    [Checkbox.name]: Checkbox,
    [Tab.name]: Tab,
    [Tabs.name]: Tabs,
    [SwipeCell.name]: SwipeCell,
    [Col.name]: Col,
    [Row.name]: Row,
    [Button.name]: Button,
    [Cell.name]: Cell,
    [Dialog.Component.name]: Dialog.Component,
    [ImagePreview.name]: ImagePreview,
    [Field.name]: Field,
  },
  mixins: [mixins],
  created() {
    this.init();
  },
  methods: {
    init() {
      this.getDetail();
    },

    add(type) {
      this[`info${type}`].push(
        type === 1
          ? {
              singleBoxQty: "",
              boxCount: "",
              boxLength: "",
              boxWidth: "",
              boxHeight: "",
              boxWeight: "",
              inStockSKUCode: "",
              startBoxNo: "",
              endBoxNo: "",
            }
          : {
              singleBoxQty: "",
              boxLength: "",
              boxWidth: "",
              boxHeight: "",
              boxWeight: "",
              inStockSKUCode: "",
              startBoxNo: "",
            }
      );
    },

    del(type, i) {
      const that = this;
      const len = that[`info${type}`].length;
      const msg = len === 1 ? "清空" : "删除";
      Dialog.confirm({
        title: msg,
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        message: `确认进行${msg}操作吗？`,
      })
        .then(() => {
          if (len === 1) {
            that[`info${type}`].splice(i, 1);
            that.add(type);
            return;
          }

          that[`info${type}`].splice(i, 1);
        })
        .catch(() => {});

      // const {shippingPlanDetailID} = this[`info${type}`][i]

      // Array.prototype.indexOf = function(val) {
      // 	for (var i = 0; i < this.length; i++) {
      // 		if (this[i] == val) return i;
      // 	}
      // 	return -1;
      // };

      // Array.prototype.remove = function(val) {
      // 	var index = this.indexOf(val);
      // 	if (index > -1) {
      // 		this.splice(index, 1);
      // 	}
      // };

      // if(this.shippingPlanDetailIDs.includes(shippingPlanDetailID)){
      // 	this.shippingPlanDetailIDs.remove(shippingPlanDetailID)
      // }
    },

    getDetail() {
      const { shippingPlanDetailID, stockingTaskID } = this.$route.query;
      const data = {
        shippingPlanDetailIDS: shippingPlanDetailID,
        stockingTaskID: stockingTaskID,
      };
      getBaleSkuDetail(data).then((res) => {
        if (res.status === 200 && res.success) {
          const { response } = res;

          let flag = false;
          if (response.wholeCase.length) {
            this.info1 = response.wholeCase;
            response.wholeCase.forEach((item) => {
              if (item.stockingBoxSumID) {
                flag = true;
              }
              if (
                item.shippingPlanDetailID &&
                !this.shippingPlanDetailIDs.includes(item.shippingPlanDetailID)
              ) {
                this.shippingPlanDetailIDs.push(item.shippingPlanDetailID);
              }
            });
          }

          if (response.theTrunk.length) {
            response.theTrunk.forEach((item) => {
              item.triggerCount = 1;
              if (item.stockingBoxSumID) {
                flag = true;
              }
              if (
                item.shippingPlanDetailID &&
                !this.shippingPlanDetailIDs.includes(item.shippingPlanDetailID)
              ) {
                this.shippingPlanDetailIDs.push(item.shippingPlanDetailID);
              }
            });
            this.info2 = response.theTrunk;
          }

          // 判断是否编辑
          if (flag) {
            this.isEdit = true;
          }

          if (response.urlPath && response.urlPath.length) {
            response.urlPath.forEach((item, i) => {
              response.urlPath[
                i
              ] = `data:image/jpg;base64,${response.urlPath[i]}`;
            });

            this.skuImg = response.urlPath;
          }

          this.saveImgUrlArr = response.imgUrlList || [];

          this.saveMaxNoArr.push(response.cartonNo);

          this.list = response;
        } else {
          Toast.fail(res.msg);
        }
      });
    },

    // 处理整箱的单箱数量
    inputStockSKUCodeChange(i) {
      if (this.info1[i].singleBoxQty.length > 10)
        this.$set(
          this.info1[i],
          "singleBoxQty",
          this.info1[i].singleBoxQty.slice(0, 10)
        );

      this.$set(
        this.info1[i],
        "inStockSKUCode",
        this.info1[i].singleBoxQty
          ? `${this.list.taskDetail[0].skuCode}-N${this.info1[i].singleBoxQty}`
          : ""
      );
    },

    // 处理尾箱的单箱数量和箱号
    inputStockSKUCodeChange2(i) {
      const that = this;
      this.$set(
        this.info2[i],
        "inStockSKUCode",
        this.info2[i].singleBoxQty
          ? `${this.list.taskDetail[0].skuCode}-N${this.info2[i].singleBoxQty}`
          : ""
      );

      if (!this.info2[i].singleBoxQty) {
        this.$set(this.info2[i], "startBoxNo", "");
      }

      // 统计函数触发次数
      this.info2[i].triggerCount++;

      if (this.isEdit) {
        let n = this.saveMaxNoArr.length
          ? Math.max(...this.saveMaxNoArr)
          : this.list.cartonNo;
        if (n === this.info2[i].startBoxNo) {
          // 处于一行重复编辑中
          this.$set(this.info2[i], "startBoxNo", this.info2[i].startBoxNo);
          this.saveMaxNoArr.push(this.info2[i].startBoxNo);
        } else {
          if (this.info2[i].triggerCount <= 2) {
            this.$set(this.info2[i], "startBoxNo", this.info2[i].startBoxNo);
          } else {
            this.$set(this.info2[i], "startBoxNo", n + 1);
            this.saveMaxNoArr.push(n + 1);
          }
        }
        return;
      }

      // function fn(){
      // 	const len = that.info1.length
      // 	for(var i=len;i--;){
      // 		if(that.info1[i].boxCount) return that.info1[i].endBoxNo
      // 	}
      // }

      // 拿到info1 的所有end箱号
      let info1EndBoxNoArr = [];
      for (let n = 0; n < this.info1.length; n++) {
        if (this.info1[n].boxCount) {
          info1EndBoxNoArr.push(this.info1[n].endBoxNo);
        }
      }

      let info1MaxBoxNo = info1EndBoxNoArr.length
        ? Math.max(...info1EndBoxNoArr)
        : this.list.cartonNo;
      let arr = [];

      for (let m = 0; m < this.info2.length; m++) {
        if (this.info2[m].singleBoxQty) {
          let num = arr.length ? arr[arr.length - 1] + 1 : info1MaxBoxNo + 1;
          this.$set(this.info2[m], "startBoxNo", Number(num));
          arr.push(num);
        }
      }
    },

    // 处理整箱的箱号
    inputBoxCodeChange(i) {
      if (String(this.info1[i].boxCount).length > 10)
        this.$set(
          this.info1[i],
          "boxCount",
          Number(String(this.info1[i].boxCount).slice(0, 10))
        );

      let arr = [];

      if (!this.info1[i].boxCount) {
        this.$set(this.info1[i], "startBoxNo", "");
        this.$set(this.info1[i], "endBoxNo", "");
      }

      if (this.isEdit) {
        let n = this.saveMaxNoArr.length
          ? Math.max(...this.saveMaxNoArr)
          : this.list.cartonNo;
        if (n === this.info1[i].endBoxNo) {
          // 处于一行重复编辑中
          this.$set(this.info1[i], "startBoxNo", this.info1[i].startBoxNo);
          this.$set(
            this.info1[i],
            "endBoxNo",
            Number(this.info1[i].startBoxNo) -
              1 +
              Number(this.info1[i].boxCount)
          );
          this.saveMaxNoArr = [
            Number(this.info1[i].startBoxNo) -
              1 +
              Number(this.info1[i].boxCount),
          ];
        } else {
          this.$set(this.info1[i], "startBoxNo", n + 1);
          this.$set(
            this.info1[i],
            "endBoxNo",
            Number(n) + Number(this.info1[i].boxCount)
          );
          this.saveMaxNoArr.push(Number(n) + Number(this.info1[i].boxCount));
        }
        return;
      } else {
        this.$set(this.info1[i], "startBoxNo", this.list.cartonNo + 1);
        this.$set(
          this.info1[i],
          "endBoxNo",
          Number(this.list.cartonNo) + Number(this.info1[i].boxCount)
        );
      }

      arr.push(this.info1[0].endBoxNo);
      for (let m = 1; m < this.info1.length; m++) {
        if (this.info1[m].boxCount) {
          this.$set(
            this.info1[m],
            "startBoxNo",
            Number(arr[arr.length - 1]) + 1
          );
          this.$set(
            this.info1[m],
            "endBoxNo",
            Number(arr[arr.length - 1]) + Number(this.info1[m].boxCount)
          );

          arr.push(this.info1[m].endBoxNo);
        }
      }

      this.inputStockSKUCodeChange2(0);
    },

    // 接口验证箱号是否重复
    getBaleHasBoxNums() {
      const { containerNo } = this.list.taskDetail[0];

      let endBoxNo;

      let flag1 = false;
      this.info2.forEach((item) => {
        if (item.singleBoxQty) flag1 = true;
      });

      let flag2 = false;
      this.info2.forEach((item) => {
        if (item.singleBoxQty) flag2 = true;
      });

      if (this.info2.length && flag1 && this.info1.length && flag2) {
        let arr = [];
        this.info2.forEach((item) => {
          arr.push(item.endBoxNo);
        });

        endBoxNo = Math.max(...arr);
      }

      this.info1.forEach((item) => {
        if (item.boxCount) {
          endBoxNo = 1;
        }
      });

      const data = {
        containerNo,
        startBoxNo: 1,
        endBoxNo,
      };
      getBaleHasBoxNum(data).then((res) => {});
    },

    // 前端验证打包数是否大于调拨数
    checkActualQty() {
      let arr = [],
        that = this;
      for (let i = 0; i < this.info1.length; i++) {
        arr.push(
          Number(this.info1[i].singleBoxQty) * Number(this.info1[i].boxCount)
        );
      }

      for (let j = 0; j < this.info2.length; j++) {
        arr.push(Number(this.info2[j].singleBoxQty));
      }

      var sum = arr.reduce(function (prev, cur) {
        return prev + cur;
      });

      function reset(bool) {
        that.info1.forEach((item, i) => {
          that.$set(that.info1[i], "quantityOut", bool);
        });
        that.info2.forEach((item, i) => {
          that.$set(that.info2[i], "quantityOut", bool);
        });
      }

      reset(false);

      if (sum > this.list.taskDetail[0].quantity) {
        reset(true);
        return true;
      }
      return false;
    },

    // 前端验证箱号是否和箱数相符
    checkBoxNoOrBoxCount() {
      let flag = false;
      for (let i = 0; i < this.info1.length; i++) {
        const { startBoxNo, endBoxNo, boxCount } = this.info1[i];

        // 先重置BoxNoOrBoxCount
        if (this.info1[i].BoxNoOrBoxCount) {
          this.$set(this.info1[i], "BoxNoOrBoxCount", false);
        }

        if (
          boxCount &&
          Number(endBoxNo) - Number(startBoxNo) + 1 !== Number(boxCount)
        ) {
          this.$set(this.info1[i], "BoxNoOrBoxCount", true);
          Toast("箱号与箱数不符");
          flag = true;
        }
      }

      return flag;

      // for (let i = 0; i < this.info2.length; i++) {
      // 	const {startBoxNo,endBoxNo,boxCount} = this.info2[i]
      // 	if(Number(endBoxNo)-Number(startBoxNo) !== Number(boxCount)){
      // 		return Toast('箱号与箱数不符')
      // 	}
      // }
    },

    // 前端验证箱号是否重复
    boxNoIsRepet() {
      let arr1 = [],
        arr2 = [];
      this.info1.forEach((item, i) => {
        if (item.boxCount) {
          arr1.push(`${item.startBoxNo}-${item.endBoxNo}-1-${i}`);
        }

        // 重置重复字段
        if (item.boxNoRepet) {
          this.$set(this.info1[i], "boxNoRepet", false);
        }
      });

      this.info2.forEach((item, i) => {
        if (item.boxCount) {
          arr2.push(`${item.startBoxNo}-${item.startBoxNo}-2-${i}`);
        }

        // 重置重复字段
        if (item.boxNoRepet) {
          this.$set(this.info2[i], "boxNoRepet", false);
        }
      });

      arr1.concat(arr2);
      let flag = false;
      for (let i = 0; i < arr1.length; i++) {
        let ar1 = arr1[i].split("-");
        for (let j = ar1[0]; j < Number(ar1[1]) + 1; j++) {
          // 每一个数字和数组内的其它元素的遍历值进行判断是否相同
          for (let m = 0; m < arr1.length; m++) {
            if (m === i) continue;

            let ar2 = arr1[m].split("-");
            for (let k = Number(ar2[0]); k < Number(ar2[1]) + 1; k++) {
              if (Number(j) === Number(k)) {
                // 存在重复值
                // console.log('存在重复值-info',ar1[2],'-第',ar1[3]+'列')
                // console.log('存在重复值-info',ar2[2],'-第',ar2[3]+'列')
                this.$set(this[`info${ar1[2]}`][ar1[3]], "boxNoRepet", true);
                flag = true;
              }
            }
          }
        }
      }

      return flag;
    },

    // 检测是否写完全部信息
    checkAllInfo() {
      const arr1 = [
        "singleBoxQty",
        "boxCount",
        "boxLength",
        "boxWidth",
        "boxHeight",
        "boxWeight",
        "inStockSKUCode",
        "startBoxNo",
        "endBoxNo",
      ];
      const arr2 = [
        "singleBoxQty",
        "boxLength",
        "boxWidth",
        "boxHeight",
        "boxWeight",
        "inStockSKUCode",
        "startBoxNo",
      ];

      for (let i = 0; i < this.info1.length; i++) {
        const {
          singleBoxQty,
          boxCount,
          boxLength,
          boxWidth,
          boxHeight,
          boxWeight,
          inStockSKUCode,
          startBoxNo,
          endBoxNo,
        } = this.info1[i];
        if (
          singleBoxQty ||
          boxCount ||
          boxLength ||
          boxWidth ||
          boxHeight ||
          boxWeight ||
          inStockSKUCode ||
          startBoxNo ||
          endBoxNo
        ) {
          for (const key in this.info1[i]) {
            if (arr1.includes(key)) {
              if (!this.info1[i][key] || this.info1[i][key] === "0.00") {
                Toast(`请输入整箱${this.itemName[key]}`);
                return false;
              }
            }
          }
        }
      }

      // 尾箱一个输入框有值，其它的都必填
      for (let i = 0; i < this.info2.length; i++) {
        const {
          singleBoxQty,
          boxLength,
          boxWidth,
          boxHeight,
          boxWeight,
          inStockSKUCode,
          startBoxNo,
        } = this.info2[i];
        if (
          singleBoxQty ||
          boxLength ||
          boxWidth ||
          boxHeight ||
          boxWeight ||
          inStockSKUCode ||
          startBoxNo
        ) {
          for (const key in this.info2[i]) {
            if (arr2.includes(key)) {
              if (!this.info2[i][key] || this.info2[i][key] === "0.00") {
                Toast(`请输入尾箱${this.itemName[key]}`);
                return false;
              }
            }
          }
        }
      }
      return true;
    },

    // 检测有没有改动
    // checkAllChange(){
    //     if(this.isObjectValueEqual(this.submitData1,this.list.wholeCase) && this.isObjectValueEqual(this.submitData2,this.info)){
    //         return true
    //     }else{
    //         return false
    //     }
    // },

    submit() {
      const that = this;

      if (!this.checkAllInfo()) return;

      // if(this.checkAllChange()) return Toast('没有要提交的改动')

      if (this.saveImgUrlArr.length < 2) return Toast("最少两张照片");

      const data = [];
      this.info1.forEach((item, i) => {
        if (item.boxCount) {
          item.boxType = 1;
          item.sourceNo = item.sourceNo || this.list.taskDetail[0].sourceNo;
          item.shippingPlanDetailID =
            item.shippingPlanDetailID ||
            this.list.taskDetail[0].shippingPlanDetailID;
          item.stockingBoxSumID =
            item.stockingBoxSumID || this.list.taskDetail[0].stockingBoxSumID;
          item.stockingTaskID =
            item.stockingTaskID || this.list.taskDetail[0].stockingTaskID;
          item.stockingBoxListID =
            item.stockingBoxListID || this.list.taskDetail[0].stockingBoxListID;
          data.push(item);
        }
      });

      this.info2.forEach((item, i) => {
        if (item.startBoxNo) {
          item.boxType = 3;
          item.boxCount = 1;
          item.endBoxNo = item.startBoxNo;
          item.sourceNo = item.sourceNo || this.list.taskDetail[0].sourceNo;
          item.shippingPlanDetailID =
            item.shippingPlanDetailID ||
            this.list.taskDetail[0].shippingPlanDetailID;
          item.stockingBoxSumID =
            item.stockingBoxSumID || this.list.taskDetail[0].stockingBoxSumID;
          item.stockingTaskID =
            item.stockingTaskID || this.list.taskDetail[0].stockingTaskID;
          item.stockingBoxListID =
            item.stockingBoxListID || this.list.taskDetail[0].stockingBoxListID;
          data.push(item);
        }
      });

      if (data.length) {
        if (!this.isEdit) {
          if (this.boxNoIsRepet()) return Toast("箱号重复");
        }

        if (this.checkBoxNoOrBoxCount()) return Toast("箱号与箱数不符");

        if (this.checkActualQty()) return Toast("装箱数已超拣货数");
      } else {
        return Toast("请至少输入一种类型");
      }

      data.forEach((item, i) => {
        delete data[i].quantityOut;
        delete data[i].BoxNoOrBoxCount;
        delete data[i].boxNoRepet;
        delete data[i].triggerCount;
      });

      let ids = [this.list.taskDetail[0].shippingPlanDetailID];
      const obj = {
        boxList: data,
        file: this.saveImgUrlArr,
        shippingPlanDetailIDs: ids.toString() || "",
      };

      Toast.loading({
        message: "打包中...",
        forbidClick: true,
        overlay: true,
        duration: 0,
      });

      console.log("----obj", obj);
      AddReadyTaskPackaging(obj).then((res) => {
        Toast.clear();
        if (res.status === 200 && res.success) {
          Toast.success(res.msg || "打包成功");

          setTimeout(function () {
            that.$router.go(-1);
          }, 1500);
        } else {
          Toast.fail(res.msg);
        }
      });
    },

    deleteImg(i) {
      this.skuImg.splice(i, 1);
      // this.imgFiles.splice(i,1)
      this.saveImgUrlArr.splice(i, 1);
    },

    changeImg() {
      const img = document.getElementsByClassName("img")[0];
      let imgList = [...img.files];

      this.imgFiles.push(...imgList);

      this.handleFiles(imgList);

      this.submitImg();
    },

    chooseImage() {
      document.getElementsByClassName("img")[0].click();
    },

    // 预览图片
    previewImage(url) {
      ImagePreview({
        images: [url],
        closeable: true,
      });
    },

    handleFiles(files) {
      const that = this;
      let srcArr = []; // 保存转换的base64 imgFileUrl

      for (var i = 0; i < files.length; i++) {
        var file = files[i];

        const { type, name } = file;

        var imageType = /^image\//;
        if (!imageType.test(type)) {
          continue;
        }

        var reader = new FileReader();
        reader.onload = function (e) {
          that.$set(that.skuImg, that.skuImg.length, e.target.result);
        };
        reader.readAsDataURL(file);
      }
    },

    submitImg() {
      const that = this;

      let formDatas = new FormData();

      this.imgFiles.forEach((i, index) => {
        formDatas.append("files", i);
      });

      Toast.loading({
        message: "保存中...",
        forbidClick: true,
        overlay: true,
        duration: 0,
      });

      axios({
        url: `${BaseApiUrl}/Img/InsertFtpImage`,
        method: "post",
        data: formDatas,
        headers: { "Content-Type": "multipart/form-data" },
      }).then((res) => {
        Toast.clear();
        if (res.data.status === 200 && res.data.success) {
          this.saveImgUrlArr.push(...res.data.response);
          this.imgFiles = [];
        } else {
          Toast.fail(res.data.msg);
        }
      });
    },

    inputLenChange(name, i, field, fix = 1) {
      let s = this[name][i][field];
      if (s.includes(".")) {
        const m = s.split(".")[0];
        if (m.length > 3) {
          this.$set(this[name][i], field, Number(`${m.slice(0, 3)}.${m[1]}`));
        }
      } else {
        if (s.length > 3) {
          this.$set(this[name][i], field, this[name][i][field].slice(0, 3));
        }
      }
    },

    inputNumChange(name, i, field, fix = 1) {
      function toF(n, fix) {
        return Number(n).toFixed(fix);
      }

      let s = this[name][i][field];

      let num = toF(s, fix);
      if (num < 0) {
        Toast("请输入正数");
        num = toF(0, fix);
      }

      this.$set(this[name][i], field, num);
    },

    inputParseIntNumChange(name, i, field) {
      let num = Number(this[name][i][field]);
      if (num < 0) {
        Toast("请输入正整数");
        num = Math.abs(num);
      }
      this.$set(this[name][i], field, parseInt(num));

      if (field === "singleBoxQty") {
        this.$set(
          this[name][i],
          "inStockSKUCode",
          this[name][i].singleBoxQty
            ? `${this.list.taskDetail[0].skuCode}-N${this[name][i].singleBoxQty}`
            : ""
        );
      }

      if (name === "info1" && field === "boxCount") {
        if (String(this.info1[i].boxCount).length > 10)
          this.$set(
            this.info1[i],
            "boxCount",
            Number(String(this.info1[i].boxCount).slice(0, 10))
          );
      }
    },

    isObjectValueEqual(a, b) {
      var aProps = Object.getOwnPropertyNames(a);

      for (var i = 0; i < aProps.length; i++) {
        var propName = aProps[i];
        var propA = a[propName];
        var propB = b[propName];
        if (propA !== propB && propName != "__ob__") {
          return false;
        }
      }
      return true;
    },
  },

  watch: {
    // 'info2': {
    // 	handler(n, o) {
    // 	},
    // 	deep: true
    // }
  },
};
</script>

<style lang="less" scoped>
@import "../../../../style/mobile_common.less";
.item-info {
  padding: 10px;
  font-size: 14px;
  background-color: #f2f2f2;
  .item-ul {
    .item-li {
      display: flex;
      align-content: flex-start;
      word-break: break-all;
      & > div {
        flex: 1;
        line-height: 25px;
        & > span {
          vertical-align: text-top;
          &:first-child {
            text-align: end;
            padding-right: 10px;
            width: 40%;
            display: inline-block;
          }
          &:last-child {
            color: #3d5064;
          }
        }
        & > p {
          line-height: 20px;
          vertical-align: middle;
          color: #3d5064;
          margin: 0;
        }
      }
    }
  }
}
.conventionalBox-info {
  font-size: 14px;
  .signInDetail-btnBox {
    background-color: #fbf9fe;
    padding: 10px;
    border-bottom: 1px solid #cccccc;
    li {
      line-height: 40px;
      white-space: nowrap;
      display: flex;
      align-items: baseline;
    }
    .volume {
      min-width: 10%;
      max-width: 27%;
      height: 22px;
      line-height: 22px;
      font-size: 12px;
      border: 0;
      background-color: #fbf9fe;
      border-bottom: 1px solid #757474;
      outline: none;
      margin: 0 5px;
      padding: 0 5px;
      box-sizing: border-box;
    }
    &:last-child {
      border-bottom: 0;
    }
  }
}
.sign-photo-box {
  margin: 5px 10px 10px;
  box-sizing: border-box;
  padding: 10px;
  ul {
    .sign-photo-item {
      width: 30.333%;
      height: 100px;
      border: 5px solid #ccc;
      box-sizing: border-box;
      position: relative;
      float: left;
      margin: 0 4.5% 4.5% 0;
      line-height: 127px;
      overflow: hidden;
      box-shadow: 0px 0px 7px -1px #cccccc;
      &:nth-child(3n) {
        margin-right: 0;
      }
      .delete-icon {
        position: absolute;
        background: red;
        color: #fff;
        width: 16px;
        height: 16px;
        top: 0px;
        right: 0px;
        line-height: 16px;
        font-size: 12px;
        border-radius: 16px;
        text-align: center;
      }
      .sign-photo-item-img {
        width: auto;
        height: 100%;
      }
    }
    .sign-photo-btn {
      display: inline-block;
      vertical-align: top;
      width: 30.333%;
      .photo {
        height: 100px;
        background-color: #faf9fc;
        position: relative;
        box-shadow: 0px 0px 7px -1px #cccccc;
        p {
          border: 1px dashed #ccc;
          padding: 10px;
          width: 50px;
          height: 50px;
          position: absolute;
          top: 50%;
          left: 50%;
          transform: translate(-50%, -50%);
          margin: 0;
          i {
            font-size: 40px;
            color: #ccc;
            position: absolute;
            top: 50%;
            left: 50%;
            transform: translate(-50%, -50%);
          }
        }
      }
    }
  }
}
.sign-photo-save {
  padding: 0 10px;
}
.photo {
  font-size: 14px;
}
.submit-btn {
  width: 100%;
  height: 40px;
  border-radius: 5px;
  background-color: #169bd5;
  color: #fff;
  font-size: 18px;
  border: 0;
}
.hidden {
  display: none;
}
.addInfo,
.delInfo {
  position: absolute;
  right: 1%;
  color: #027db4;
}
.delInfo {
  right: 13%;
  color: #da2727;
}
.p-title {
  font-weight: 600;
  margin-bottom: 0;
  padding-left: 10px;
}
::v-deep .van-cell {
  line-height: 20px;
}
.tips {
  position: absolute;
  left: -50px;
  top: 33px;
  font-size: 12px;
  line-height: 20px;
}
.vm {
  vertical-align: middle;
}
</style>